// A CLIENT'S CONTACT PEOPLE as the forms edit them (migration 071) — pure helpers behind
// components/ContactsEditor, used by the client form, the lead form and the client card.
//
// The server holds the rules (clients/contacts.js) and refuses what breaks them; these
// keep the form honest before it is sent: one main contact at all times while there are
// any, an empty row ignored, and a role with no person behind it named as the problem.
let nextKey = 0;
const key = () => { nextKey += 1; return `c${nextKey}`; };

const blank = (isMain = false) => ({ key: key(), name: '', phone: '', email: '', role: '', is_main: isMain });
const asRow = (c) => ({
  key: key(), name: c.name || '', phone: c.phone || '', email: c.email || '', role: c.role || '', is_main: !!c.is_main,
});

// The form's rows from a client: its whole set when the client was read in full, else
// its main contact from the three fields every list carries, else one empty main row so
// a new client's form opens ready to type into.
export const initialContacts = (client = {}) => {
  if (Array.isArray(client.contacts) && client.contacts.length) return client.contacts.map(asRow);
  if (client.contact_name || client.phone || client.email) {
    return [asRow({ name: client.contact_name, phone: client.phone, email: client.email, is_main: true })];
  }
  return [blank(true)];
};

export const addContact = (rows) => [...rows, blank(rows.length === 0)];

// Removing the main contact hands "main" to the first one left.
export const removeContact = (rows, k) => {
  const left = rows.filter((r) => r.key !== k);
  if (left.length && !left.some((r) => r.is_main)) left[0] = { ...left[0], is_main: true };
  return left;
};

export const setMain = (rows, k) => rows.map((r) => ({ ...r, is_main: r.key === k }));

export const updateContact = (rows, k, field, value) => rows.map((r) => (r.key === k ? { ...r, [field]: value } : r));

const filled = (v) => String(v || '').trim() !== '';
const isEmpty = (r) => !['name', 'phone', 'email', 'role'].some((f) => filled(r[f]));

// A row with a role and no name, phone or email — the one thing the server refuses that
// a person can type. Save stays dark while one exists, and the editor says which.
export const needsDetail = (r) => !isEmpty(r) && !filled(r.name) && !filled(r.phone) && !filled(r.email);
export const contactsValid = (rows) => !rows.some(needsDetail);

// What the server is sent: every row that has anything in it, main first. If the main
// row is the empty one, the first filled row becomes main, as the server would make it.
export const contactsPayload = (rows) => {
  const kept = rows.filter((r) => !isEmpty(r));
  if (kept.length && !kept.some((r) => r.is_main)) kept[0] = { ...kept[0], is_main: true };
  return kept.map(({ name, phone, email, role, is_main: isMain }) => ({
    name: name.trim() || null, phone: phone.trim() || null, email: email.trim() || null,
    role: role.trim() || null, is_main: isMain,
  }));
};
